// DS: i5.3
import React from 'react';
import IconWrap from '../../IconWrap';
// this is used in shared/FaveButton/FavingIcon
export function getFavouriteOutlineIconMarkup(className) {
    return /*#__PURE__*/ React.createElement("path", {
        className: className,
        fillRule: "evenodd",
        d: "M13.71 3.408A1 1 0 0012.904 3h-1.85l-.119.007a1 1 0 00-.75.499L8.122 7.134l-4.57.641-.124.025a1 1 0 00-.688.656l-.544 1.67-.032.124a1 1 0 00.297.915l3.265 3.07-.766 4.33-.014.128a1 1 0 00.43.869l1.567 1.081.117.07a1 1 0 00.904-.001L12 18.66l4.116 2.07.127.054a1 1 0 00.898-.128l1.524-1.072.1-.08a1 1 0 00.308-.919l-.8-4.35 3.257-3.063.089-.095a1 1 0 00.172-.957l-.564-1.65-.047-.115a1 1 0 00-.76-.551l-4.58-.643-2.065-3.653-.065-.1zM11.635 5h.685l2.264 4.004 4.95.695.155.457-3.58 3.369.88 4.792-.51.358-4.484-2.256-4.407 2.239-.546-.377.842-4.762-3.59-3.377.155-.474 4.926-.69L11.635 5z"
    });
}
const FavStar = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, getFavouriteOutlineIconMarkup()));
FavStar.displayName = 'FavStar';
export default FavStar;
